import classNames from "classnames";
import { DateTime } from "luxon";
import { useState } from "react";
import { useHistory } from "react-router";
import { common_utils } from "../../../../../../../../../common/common_utils";
import { Constants } from "../../../../../../../../../common/constants";
import { EventDisplayData } from "../../../../../../../../../common/sesh_types";
import { NativeEventDisplayData } from "../../../../../../../../../src/shard_api/routes/getNativeEvents";
import { RemovingThrobber } from "../../../../../removing_throbber";
import { SeshPrimaryButton } from "../../../../base_components/sesh_primary_button";
import { WithDropdownBase } from "../../../../base_components/with_dropdown_base";
import { BoxItem } from "../../../../box_item";
import { useServerId } from "../../../../hooks/use_server_id";
import { useHistoryPusher } from "../hooks/use_history_pusher";
import { isSeshEvent } from "../utils/is_sesh_event";
import {
	DiscordEventItemDropdown,
	SeshEventItemDropdown,
} from "./calendar_event_item_dropdown";
import { CalendarEventDisplayData } from "./calendar_page";

export function MobileCalendarEventList(props: {
	date: DateTime;
	events: CalendarEventDisplayData[];
}) {
	const guild_id = useServerId();

	const pushHistory = useHistoryPusher();

	return (
		<div className="flex flex-col gap-1">
			{props.events.length > 0 ? (
				props.events.map((val, idx) => (
					<MobileEventItem key={idx.toString()} event={val} />
				))
			) : (
				<BoxItem
					bgColor="semidark"
					className="border-l-4 border-l-inherit text-sm"
					padding="p-2"
				>
					<div className="flex w-full">No events</div>
				</BoxItem>
			)}
			<SeshPrimaryButton
				custom_size="small"
				className="mt-1"
				onClick={() =>
					pushHistory(
						common_utils.getEventCreateURL(
							guild_id,
							undefined,
							undefined,
							{
								date: props.date.set({ hour: 12 }).toISO(),
							}
						)
					)
				}
			>
				New Event
			</SeshPrimaryButton>
		</div>
	);
}

function MobileEventItem(props: { event: CalendarEventDisplayData }) {
	if (isSeshEvent(props.event)) {
		return <MobileSeshEventItem event={props.event} />;
	}

	return <MobileDiscordEventItem event={props.event} />;
}

function MobileDiscordEventItem(props: { event: NativeEventDisplayData }) {
	const [is_removing, setIsRemoving] = useState(false);

	return (
		<WithDropdownBase
			key={props.event.id + props.event.start_time_str}
			id={`${props.event.id}_${props.event.start_time_str}`}
			x_alignment="middle"
			y_alignment="top"
			dropdown_element={
				<DiscordEventItemDropdown
					event={props.event}
					is_removing={is_removing}
					setIsRemoving={setIsRemoving}
				/>
			}
			disabled={is_removing}
		>
			<span
				className={classNames("w-full", {
					"border-warning": is_removing,
				})}
				style={{
					borderLeftColor: Constants.DISCORD_BLURPLE,
				}}
			>
				<BoxItem
					bgColor="semidark"
					className={classNames("w-full border-l-4 text-sm", {
						"border-warning": is_removing,
						"border-l-inherit": !is_removing,
					})}
					padding="p-2"
				>
					<div className="flex w-full items-center gap-2">
						<div className="flex items-center gap-2 overflow-hidden overflow-ellipsis whitespace-nowrap">
							<span className="">
								<i className="fab fa-discord" />
							</span>
							{props.event.name}
						</div>
						<div className="ml-auto flex flex-shrink-0 items-center gap-2">
							<div className="text-content-secondary">
								{DateTime.fromJSDate(
									new Date(props.event.start_time_str)
								).toLocaleString({
									timeStyle: "short",
								})}
							</div>
							{is_removing && (
								<div>
									<RemovingThrobber />
								</div>
							)}
						</div>
					</div>
				</BoxItem>
			</span>
		</WithDropdownBase>
	);
}

function MobileSeshEventItem(props: { event: EventDisplayData }) {
	const [is_removing, setIsRemoving] = useState(false);

	return (
		<WithDropdownBase
			key={props.event.message_id + props.event.start_time_str}
			id={`${props.event.message_id}_${props.event.start_time_str}`}
			x_alignment="middle"
			y_alignment="top"
			dropdown_element={
				<SeshEventItemDropdown
					event={props.event}
					is_removing={is_removing}
					setIsRemoving={setIsRemoving}
				/>
			}
			disabled={is_removing}
		>
			<span
				className={classNames("w-full", {
					"border-warning": is_removing,
				})}
				style={{
					borderLeftColor: props.event.color,
				}}
			>
				<BoxItem
					bgColor="semidark"
					className={classNames("w-full border-l-4 text-sm", {
						"border-warning": is_removing,
						"border-l-inherit": !is_removing,
					})}
					padding="p-2"
				>
					<div className="flex w-full items-center gap-2">
						<div className="overflow-hidden overflow-ellipsis whitespace-nowrap">
							{props.event.name}
						</div>
						<div className="ml-auto flex flex-shrink-0 items-center gap-2">
							<div className="text-content-secondary">
								{DateTime.fromJSDate(
									new Date(props.event.start_time_str)
								).toLocaleString({
									timeStyle: "short",
								})}
							</div>
							{is_removing && (
								<div>
									<RemovingThrobber />
								</div>
							)}
						</div>
					</div>
				</BoxItem>
			</span>
		</WithDropdownBase>
	);
}
